import angular from 'angular';
import tableGridAccordionRowComponent from './tableGridAccordionRow.component';

let tableGridAccordionRowModule = angular.module('tableGridAccordionRow', []).directive('tableGridAccordionRow', tableGridAccordionRowComponent);

export default tableGridAccordionRowModule;



// WEBPACK FOOTER //
// ./app/components/tableGridAccordionRow/tableGridAccordionRow.js